let id = new Date().valueOf();
export function uid() {
    return "temp://" + id++;
}
//# sourceMappingURL=uid.js.map